<!-- <template>
<div
    ref="theoplayer"
    class="theoplayer-container video-js theoplayer-skin vjs-fill THEOplayer" />
</template>

<script>
    export default {
        props: {
            source: {type: Array, default: () => []},
            poster: {type: String, default: ''}
        },
        mounted() {
            this.playerInit();
        },
        methods: {
            playerInit() {
                const theo_lib_key = document.getElementById('THEOPLAYER_LIB_KEY').dataset.key;
                const player = new window.THEOplayer.Player(this.$refs.theoplayer, {
                    fluid: true,
                    libraryLocation: `https://cdn.myth.theoplayer.com/${theo_lib_key}`
                });
                player.source = {
                    sources: this.source,
                    poster: this.poster
                };
            }
        },
    };
</script>

<style lang="scss">
    .tile__s__video > .video-js {
        position: absolute;
    }
</style> -->

<template>
    <div class="video-player-container vjs-default-skin">
        <video
            ref="videoPlayer"
            class="video-js vjs-fill"
            :poster="poster"
            controls
            preload="auto"
            data-setup="{}"
        >
            <source
                v-for="(src, index) in source"
                :key="index"
                :src="src.src"
                :type="src.type"
            />
        </video>
    </div>
</template>
  
<script>
    export default {
        props: {
            source: { type: Array, default: () => [] },
            poster: { type: String, default: '' }
        },
        data() {
            return {
            player: null,
            hls: null
            };
        },
        mounted() {
            this.initializePlayer();
        },
        beforeDestroy() {
            // Clean up HLS instance if it exists
            if (this.hls) {
            this.hls.destroy();
            }
            
            // Clean up Video.js player
            if (this.player) {
            this.player.dispose();
            }
        },
        methods: {
            loadVideoJS() {
                return new Promise((resolve, reject) => {
                    if (window.videojs) {
                        resolve();
                        return;
                    }

                    const script = document.createElement('script');
                    script.src = 'https://vjs.zencdn.net/8.10.0/video.min.js';
                    script.onload = () => resolve();
                    script.onerror = () => reject(new Error('Failed to load Video.js'));
                    document.body.appendChild(script);
                });
            },
            initializePlayer() {
                // initVideoPlayers();
                // Wait for Video.js to be available globally
                this.loadVideoJS().then(() => {
                    this.setupPlayer();
                }).catch(error => {
                    console.error('Failed to initialize Video.js:', error);
                });
            },
            waitForVideoJS() {
            return new Promise((resolve, reject) => {
                if (window.videojs) {
                    resolve();
                    return;
                }

                // Optional: Add timeout if needed
                const timeout = setTimeout(() => {
                reject(new Error('Video.js not loaded after 5 seconds'));
                }, 5000);

                // Poll for Video.js availability
                const checkInterval = setInterval(() => {
                if (window.videojs) {
                    clearInterval(checkInterval);
                    clearTimeout(timeout);
                    resolve();
                }
                }, 100);
            });
            },
            setupPlayer() {
            const videoEl = this.$refs.videoPlayer;
            
            // Skip if already initialized
            if (videoEl.classList.contains('vjs-initialized')) {
                return;
            }

            videoEl.classList.add('vjs-initialized');

            // Initialize player using global videojs
            this.player = window.videojs(videoEl, {
                fluid: true,
                responsive: true,
                html5: {
                hls: {
                    overrideNative: true,
                    enableLowInitialBitrate: true
                },
                nativeAudioTracks: false,
                nativeVideoTracks: false,
                }
            });

            this.setupHLS();
            },
            setupHLS() {
            const videoEl = this.$refs.videoPlayer;
            const hlsSource = Array.from(videoEl.querySelectorAll('source')).find(
                src => src.type === 'application/x-mpegURL'
            );

            if (hlsSource && !videoEl.canPlayType('application/vnd.apple.mpegurl')) {
                if (window.Hls && window.Hls.isSupported()) {
                this.hls = new window.Hls({
                    enableWorker: true,
                    lowLatencyMode: true,
                    maxBufferLength: 30,
                    maxMaxBufferLength: 600,
                });
                
                this.hls.loadSource(hlsSource.src);
                this.hls.attachMedia(videoEl);
                
                this.hls.on(window.Hls.Events.MANIFEST_PARSED, () => {
                    console.log('HLS manifest loaded');
                });
                
                this.hls.on(window.Hls.Events.ERROR, (event, data) => {
                    if (data.fatal) {
                    switch(data.type) {
                        case window.Hls.ErrorTypes.NETWORK_ERROR:
                        this.hls.startLoad();
                        break;
                        case window.Hls.ErrorTypes.MEDIA_ERROR:
                        this.hls.recoverMediaError();
                        break;
                        default:
                        console.error('Unrecoverable HLS error');
                        break;
                    }
                    }
                });
                }
            }
            }
        }
    };
</script>
  
<style lang="scss">
    .video-player-container {
        position: relative;
        width: 100%;
        height: 100%;

        .video-js {
            width: 100%;
            height: 100%;
            
            &.vjs-fill {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }
        }
    }
</style>
